import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import {
	faHashtag as fasHashtag,
	faCircleInfo as fasCircleInfo,
	faArrowRight as fasArrowRight,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Alert, Button, FormCurrency, FormInput } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { validTaxNumber } from "../domain";

const MAX_MONEY_AMOUNT = 9_999_999_999;

export interface CompanyStep1Fields {
	netIncome: number;
	taxNumber: string;
}

interface Props extends AbstractStepProps {
	isAgrar: boolean;
	companyFoundYear: number;
}

export class CompanyStep1 extends AbstractStep<CompanyStep1Fields, Props> {
	protected renderContent(_values: CompanyStep1Fields, form: FormApi<CompanyStep1Fields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormCurrency
						name="netIncome"
						label="Árbevétel (utolsó lezárt év):"
						validate={this.validNetIncome}
						required
					/>
					<FormInput
						label="Adószám"
						name="taxNumber"
						prepend={<FontAwesomeIcon icon={fasHashtag} />}
						maxlength="13"
						autoComplete="nope"
						placeholder="xxxxxxxx-y-zz"
						validate={validTaxNumber}
						required
					/>
					<Alert icon={<FontAwesomeIcon icon={fasCircleInfo} />} variant="warning">
						Ha nem tudod a tényleges összegeket, <strong>elég a becsült</strong> érték!
					</Alert>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	private validNetIncome(netIncome: number, values: Record<string, any>): string {
		const { operatingProfit } = values;

		if (isNaN(netIncome)) {
			return "Add meg céged utolsó lezárt üzleti évi árbevételét!";
		}

		if (netIncome <= 0) {
			return "A cég alacsony árbevétele miatt javasoljuk lakossági hitel felvételét.";
		}

		if (netIncome < operatingProfit) {
			return "Ellenőrizd, hogy jó számokat írtál-e be, üzleti eredményed nem lehet magasabb az árbevételednél!";
		}

		if (netIncome > MAX_MONEY_AMOUNT) {
			return `Az árbevétel megadható maximális értéke ${formatText(MAX_MONEY_AMOUNT, "ft")}`;
		}
	}

	protected getComponentName(): string {
		return "CompanyStep1";
	}
}
